function onSwymLoadCallback(swat) {
  function updateSFLVisibility() {
    const listContainer = document.querySelector(".swym-sfl-list-container");
    const gridBody = document.getElementById("swym-sfl-grid-body");
    if (!listContainer || !gridBody) return;

    const hasProducts = gridBody.querySelector(".swym-sfl-container") !== null;
    listContainer.classList.toggle("hidden", !hasProducts);
  }

  function init() {
    const gridBody = document.getElementById("swym-sfl-grid-body");
    if (!gridBody) return setTimeout(init, 200);

    updateSFLVisibility();

    new MutationObserver(updateSFLVisibility).observe(gridBody, {
      childList: true,
      subtree: true,
    });

    document.addEventListener("sw:addedtoSFL", updateSFLVisibility);
    document.addEventListener("sw:removedfromSFL", updateSFLVisibility);
  }

  document.readyState === "loading"
    ? document.addEventListener("DOMContentLoaded", init)
    : init();
}

window.SwymCallbacks = window.SwymCallbacks || [];
window.SwymCallbacks.push(onSwymLoadCallback);